"use client";

import { useEffect, useState } from "react";
import { X, PartyPopper, Copy, Check } from "lucide-react";
import Link from "next/link";

export default function Modal() {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const hasSeenModal = localStorage.getItem("modalSeen");
    if (!hasSeenModal) {
      setIsOpen(true);
      localStorage.setItem("modalSeen", "true");
    }
  }, []);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText("LAUNCH30");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-xl max-w-md w-full relative animate-in fade-in zoom-in duration-300">
        {/* Close button */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute -top-2 -right-2 bg-card border border-border rounded-full p-1.5 hover:bg-muted transition-colors"
        >
          <X className="h-4 w-4 text-foreground" />
        </button>

        {/* Modal content */}
        <div className="p-6">
          {/* Promo badge */}
          <div className="inline-block bg-primary/10 text-primary text-xs font-bold px-3 py-1 rounded-full mb-4">
            LIMITED TIME OFFER
          </div>

          {/* Title */}
          <h2 className="font-heading text-2xl font-bold text-foreground mb-2 flex items-center gap-2">
            <PartyPopper className="h-6 w-6 text-primary" />
            Special Launch Promo!
          </h2>

          {/* Description */}
          <p className="font-body text-muted-foreground mb-6">
            Get 30% off on all annual plans. Offer ends soon!
          </p>

          {/* Promo code with copy button */}
          <div className="bg-muted/50 border border-border rounded-lg p-4 mb-6">
            <p className="font-body text-sm text-muted-foreground mb-2">
              Use code:
            </p>
            <div className="flex items-center justify-between gap-2">
              <p className="font-heading text-2xl font-bold text-primary">
                LAUNCH30
              </p>
              <button
                onClick={copyToClipboard}
                className="flex items-center gap-1 px-3 py-1.5 bg-primary/10 hover:bg-primary/20 text-primary rounded-lg transition-colors"
              >
                {copied ? (
                  <>
                    <Check className="h-4 w-4" />
                    <span className="text-sm font-medium">Copied!</span>
                  </>
                ) : (
                  <>
                    <Copy className="h-4 w-4" />
                    <span className="text-sm font-medium">Copy</span>
                  </>
                )}
              </button>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col gap-3">
            <Link
              href="/contact"
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-heading font-bold px-6 py-3 rounded-lg text-center transition-all duration-200 shadow-lg shadow-primary/20"
              onClick={() => setIsOpen(false)}
            >
              Claim Offer
            </Link>
            <button
              onClick={() => setIsOpen(false)}
              className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
